<template>
  <div>
    <base-confirm
      type="success"
      message="Laporan akan divalidasi. Apakah Anda yakin data yang dibuat sudah benar?"
      :visible="visible"
      @close="$emit('close')"
      @confirmed="onConfirmed"
    />
    <loading v-if="loading" />
  </div>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import BaseConfirm from '@/components/base/BaseConfirm.vue';
import { mapActions } from 'vuex';

export default {
  components: { BaseConfirm },
  mixins: [requestMixin],
  props: {
    visible: Boolean,
    id: String,
  },
  emits: ['close', 'confirmed'],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async onConfirmed() {
      this.loading = true;

      const [, err] = await this.request(
        `/api/v1/stock-loan-movement-reports/${this.id}/-actions/validate-report`,
        {
          method: 'patch',
        }
      );

      if (err) {
        this.createAlert({
          data: this.getRequestErrorMessage(err),
          status: 'error',
        });
      } else {
        this.$emit('confirmed');
      }

      this.loading = false;
    },
  },
};
</script>
